var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import styled from 'styled-components';
import WindowEventContext from '../../context/window-event-context';
import { getGeometryStyle, getHeightWidth, getMaxHeightWidth, getMinHeightWidth, } from '../../helpers/styles';
import useFormItem from '../../hooks/useFormItem';
var StyledToggleTextButton = styled.button.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n    ", "\n    ", "\n    color: ", ";\n  border: ", ";\n  background: ", ";\n  outline: ", ";\n  box-sizing: ", ";\n  border-radius: ", ";\n  cursor: ", ";\n  font-family: ", ";\n  border-left-color: ", ";\n  border-top-color: ", ";\n  border-right-color: ", ";\n  border-bottom-color: ", ";\n  background-color: ", ";\n  :focus {\n    outline: ", ";\n  }\n  :active {\n    border-left-color: ", ";\n    border-top-color: ", ";\n    border-right-color: ", ";\n    border-bottom-color: ", ";\n  }\n  :hover {\n    background-color: ", ";\n  }\n"], ["\n  ", "\n  ",
    "\n    ", "\n    ", "\n    color: ", ";\n  border: ", ";\n  background: ", ";\n  outline: ", ";\n  box-sizing: ", ";\n  border-radius: ", ";\n  cursor: ", ";\n  font-family: ", ";\n  border-left-color: ",
    ";\n  border-top-color: ", ";\n  border-right-color: ",
    ";\n  border-bottom-color: ",
    ";\n  background-color: ",
    ";\n  :focus {\n    outline: ", ";\n  }\n  :active {\n    border-left-color: ",
    ";\n    border-top-color: ",
    ";\n    border-right-color: ",
    ";\n    border-bottom-color: ",
    ";\n  }\n  :hover {\n    background-color: ",
    ";\n  }\n"])), function (_a) {
    var geometry = _a.geometry;
    return getGeometryStyle(geometry);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return getHeightWidth(windowTheme.button.width, windowTheme.button.height);
}, function (_a) {
    var minimumSize = _a.minimumSize;
    return minimumSize && getMinHeightWidth(minimumSize);
}, function (_a) {
    var maximumSize = _a.maximumSize;
    return maximumSize && getMaxHeightWidth(maximumSize);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.color;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.border;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.background;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.outline;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.boxSizing;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.borderRadius;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.cursor;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.fontFamily;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.borderColor.left;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.borderColor.top;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.borderColor.right;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.borderColor.bottom;
}, function (_a) {
    var windowTheme = _a.windowTheme, value = _a.value;
    return value
        ? windowTheme.button.toggle.onBackgroundColor
        : windowTheme.button.toggle.offBackgroundColor;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.focus.outline;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.active.borderColor.left;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.active.borderColor.top;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.active.borderColor.right;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.button.active.borderColor.bottom;
}, function (_a) {
    var windowTheme = _a.windowTheme, value = _a.value;
    return value
        ? windowTheme.button.toggle.onBackgroundColor
        : windowTheme.button.toggle.offBackgroundColor;
});
var ToggleTextButton = function (props) {
    var identifier = props.identifier, type = props.type, restProps = __rest(props, ["identifier", "type"]);
    var _a = useFormItem(identifier).value, value = _a === void 0 ? false : _a;
    var _onToggleButtonClick = useContext(WindowEventContext)._onToggleButtonClick;
    var geometry = props.attributes.geometry;
    return (React.createElement(StyledToggleTextButton, __assign({ id: identifier, "data-widget-type": type, geometry: geometry, onClick: function (evt) {
            _onToggleButtonClick(identifier, !value);
        } }, restProps, { value: value }), value ? 'On' : 'Off'));
};
export default ToggleTextButton;
var templateObject_1;
//# sourceMappingURL=index.js.map